import { Pipe, PipeTransform } from '@angular/core';
import { FormatService } from '../../services/format.service';
import { UNIT } from '../../models/types';

@Pipe({
  name: 'formatValueWithUnit'
})
export class FormatValueWithUnitPipe implements PipeTransform {
  constructor(public formatService: FormatService) {}

  transform(value: number, unit: UNIT, fallback: string = `-`): string {
    return this.formatService.formatValueWithUnit(value, unit, fallback);
  }
}
